import React, { useState, useEffect } from "react";
import {
  Form,
  Input,
  Button,
  Switch,
  message,
  Card,
  Row,
  Col,
  Select,
  Spin,
} from "antd";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../api";

const { TextArea } = Input;
const { Option } = Select;

const EditCustomerPage = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [hasBought, setHasBought] = useState(false); // اضافه کردن state جداگانه برای کنترل Switch
  const navigate = useNavigate();
  const { id } = useParams(); // دریافت شناسه مشتری از URL

  // دریافت اطلاعات مشتری برای ویرایش
  useEffect(() => {
    const fetchCustomerData = async () => {
      try {
        const response = await api.get(`/panel/call-center-request/${id}`);
        const customerData = response.data.data;

        // تنظیم مقدار has_bought در state جداگانه
        setHasBought(customerData.has_bought === 1);

        // تنظیم مقادیر فرم
        form.setFieldsValue({
          ...customerData,
          has_bought: customerData.has_bought === 1,
        });
      } catch (error) {
        console.error("Error fetching customer data:", error);
        message.error("خطا در دریافت اطلاعات مشتری");
        navigate("/call_center");
      } finally {
        setInitialLoading(false);
      }
    };

    fetchCustomerData();
  }, [id, form, navigate]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      // استفاده از مقدار state برای تنظیم has_bought
      const updatedValues = {
        ...values,
        has_bought: hasBought ? 1 : 0,
      };

      await api.put(`/panel/call-center-request/${id}`, updatedValues);
      message.success("اطلاعات مشتری با موفقیت بروزرسانی شد");
      navigate("/call_center");
    } catch (error) {
      console.error("Error updating customer:", error);
      message.error("خطا در بروزرسانی اطلاعات مشتری");
    } finally {
      setLoading(false);
    }
  };

  // تغییر مقدار has_bought
  const handleSwitchChange = (checked) => {
    setHasBought(checked);
    form.setFieldsValue({ has_bought: checked });
  };

  const handleCancel = () => {
    navigate("/call_center"); // بازگشت به صفحه‌ی قبلی
  };

  if (initialLoading) {
    return (
      <Card>
        <div className="flex justify-center items-center h-64">
          <Spin size="large" tip="در حال دریافت اطلاعات..." />
        </div>
      </Card>
    );
  }

  return (
    <Card>
      <h1 className="text-2xl font-bold mb-10">ویرایش درخواست</h1>
      <Form form={form} onFinish={onFinish} layout="vertical">
        {/* ردیف ۱: نام قطعه و موقعیت مکانی قطعه */}
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="part_name"
              label="نام قطعه"
              // rules={[{ required: true, message: "لطفا نام قطعه را وارد کنید" }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="part_position" label="موقعیت مکانی قطعه">
              <Input />
            </Form.Item>
          </Col>
        </Row>

        {/* ردیف ۲: کد فنی قطعه و برند خودرو */}
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="product_technical_code" label="کد فنی قطعه">
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="car_brand" label="برند خودرو">
              <Input />
            </Form.Item>
          </Col>
        </Row>

        {/* ردیف ۳: مدل خودرو و سال ساخت و شماره شاسی خودرو */}
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="car_model" label="مدل خودرو و سال ساخت">
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="chassis_number" label="شماره شاسی خودرو">
              <Input />
            </Form.Item>
          </Col>
        </Row>

        {/* ردیف ۴: نام و نام خانوادگی و شماره موبایل */}
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="full_name"
              label="نام و نام خانوادگی"
              rules={[
                {
                  required: true,
                  message: "لطفا نام و نام خانوادگی را وارد کنید",
                },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="number"
              label="شماره موبایل"
              rules={[
                { required: true, message: "لطفا شماره موبایل را وارد کنید" },
              ]}
            >
              <Input />
            </Form.Item>
          </Col>
        </Row>

        {/* ردیف ۵: شماره ثابت و آدرس */}
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="landline" label="شماره ثابت">
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="address" label="آدرس">
              <Input />
            </Form.Item>
          </Col>
        </Row>


        <Row gutter={16}>
          <Col span={12}>
            <Form.Item name="status" label="وضعیت">
              <Select placeholder="وضعیت را انتخاب کنید">
                <Option value="pending">در انتظار</Option>
                <Option value="priced">قیمت‌گذاری شده</Option>
                <Option value="completed">تکمیل شده</Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name="price" label=" قیمت">
              <Input />
            </Form.Item>
          </Col>
          <Col span={16}>
            <Form.Item
              name="has_bought"
              label=""
              valuePropName="checked"
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 16 }}
            >
              <div className="flex gap-32">
                <span style={{ marginRight: 8 }}>منجر به فروش شد؟</span>
                <Switch checked={hasBought} onChange={handleSwitchChange} />
              </div>
            </Form.Item>
          </Col>
        </Row>

        {/* ردیف ۷: توضیحات */}
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item name="body" label="توضیحات">
              <TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>

        {/* دکمه‌های ذخیره و انصراف */}
        <Form.Item>
          <Row gutter={16}>
            <Col>
              <Button type="primary" htmlType="submit" loading={loading}>
                بروزرسانی
              </Button>
            </Col>
            <Col>
              <Button onClick={handleCancel}>انصراف</Button>
            </Col>
          </Row>
        </Form.Item>
      </Form>
    </Card>
  );
};

export default EditCustomerPage;
